import { useUpload } from "../upload/useUpload";

type UseUploadDialogParams = {
  setIsOpen: (isOpen: boolean) => void;
  fetchFiles: () => void;
};

export function useUploadDialog({
  setIsOpen,
  fetchFiles,
}: UseUploadDialogParams) {
  function onClose() {
    setIsOpen(false);
    fetchFiles();
  }

  return {
    ...useUpload({ onCloseDialog: onClose }),
  };
}
